import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M1.5 12.5V3.5C1.5 2.94772 1.94772 2.5 2.5 2.5H5.88197C6.26074 2.5 6.607 2.714 6.77639 3.05279L7.22361 3.94721C7.393 4.286 7.73926 4.5 8.11803 4.5H13.5C14.0523 4.5 14.5 4.94772 14.5 5.5V12.5C14.5 13.0523 14.0523 13.5 13.5 13.5H2.5C1.94772 13.5 1.5 13.0523 1.5 12.5Z"
            stroke="currentColor"
        />
    </svg>
);

export default Icon;
